import script from "./noCard.vue?vue&type=script&setup=true&lang=js"
export * from "./noCard.vue?vue&type=script&setup=true&lang=js"

import "./noCard.vue?vue&type=style&index=0&id=f51688ce&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f51688ce"]])

export default __exports__